export default "__VITE_ASSET__DA7_46w9__"